<template>
    <img :class="['thumbnail__background-image', {'vertical': isVertical }]"
         :srcset="`${getBackgroundImage().x1} 1x, ${getBackgroundImage().x2} 2x`"
         :src="getBackgroundImage().x1"
         alt=""
         v-if="getBackgroundImage()"
    />
</template>

<script>
export default {
    name: 'thumbnail-background-image',
    props: {
        course: {
            type: Object,
            required: true
        },
        isVertical: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getBackgroundImage () {
            if (this.course.thumbnail?.backgroundImageUrl !== null && this.course.thumbnail?.backgroundImageUrl !== undefined) {

                if (this.isMobileView) {
                    return {
                        x1: this.course.thumbnail.backgroundImageUrl.mobile.x1,
                        x2: this.course.thumbnail.backgroundImageUrl.mobile.x2
                    }
                }

                return {
                    x1: this.course.thumbnail.backgroundImageUrl.desktop.x1,
                    x2: this.course.thumbnail.backgroundImageUrl.desktop.x2
                }

            }

            return false
        }
    }
}
</script>

<style lang="scss" scoped>
    .thumbnail {
        &__background-image {
            align-self: flex-start;
            object-fit: cover;
            object-position: left;


            [class*="desktop"] & {
                width: 100%;
                height: 229px;
            }

            &.vertical {
                height: 100%;
                width: 340px;
            }

            [class*="mobile"] & {
                width: 100%;
                height: 100px;
            }
        }
    }
</style>
